(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-collection-hub"] && !Shopify.designMode) return;
  try {
    
  const activateDynamicCollection = (hub, handle, updateHistory) => {
    const categories = Array.from(hub.querySelectorAll('[data-collection-handle]'));
    const panels = Array.from(hub.querySelectorAll('[data-collection-panel]'));
    const selectedCategory = categories.find((category) => category.dataset.collectionHandle === handle);
    const selectedPanel = panels.find((panel) => panel.dataset.collectionPanel === handle);
    if (!selectedCategory || !selectedPanel) return;

    const update = () => {
      categories.forEach((category) => {
        const active = category === selectedCategory;
        category.classList.toggle('is-active', active);
        category.setAttribute('aria-current', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        panel.hidden = panel !== selectedPanel;
      });
    };

    if (document.startViewTransition) {
      document.startViewTransition(update);
    } else {
      update();
    }

    if (updateHistory) {
      const url = new URL(window.location.href);
      url.searchParams.set('collection', handle);
      window.history.pushState({ collection: handle }, '', url);
    }

    document.dispatchEvent(new CustomEvent('dynamic-collection:change', { detail: { handle } }));
  };

  if (!window.dynamicCollectionHubEventsBound) {
    window.dynamicCollectionHubEventsBound = true;

    document.addEventListener('click', (event) => {
      const category = event.target.closest('[data-dynamic-collection-hub] [data-collection-handle]');
      if (!category) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const hub = category.closest('[data-dynamic-collection-hub]');
      event.preventDefault();
      activateDynamicCollection(hub, category.dataset.collectionHandle, true);
    });

    window.addEventListener('popstate', () => {
      document.querySelectorAll('[data-dynamic-collection-hub]').forEach((hub) => {
        const handle = new URL(window.location.href).searchParams.get('collection') || hub.dataset.initialHandle;
        activateDynamicCollection(hub, handle, false);
      });
    });
  }

  document.querySelectorAll('[data-dynamic-collection-hub]').forEach((hub) => {
    const requestedHandle = new URL(window.location.href).searchParams.get('collection');
    if (requestedHandle) activateDynamicCollection(hub, requestedHandle, false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-collection-image-with-text"] && !Shopify.designMode) return;
  try {
    
  const activateDynamicCollectionImageWithText = (handle) => {
    document.querySelectorAll('[data-dynamic-collection-image-with-text]').forEach((section) => {
      const panels = Array.from(section.querySelectorAll('[data-collection-image-with-text-panel]'));
      const selectedPanel = panels.find((panel) => panel.dataset.collectionImageWithTextPanel === handle);
      if (!selectedPanel) return;

      panels.forEach((panel) => {
        panel.hidden = panel !== selectedPanel;
      });
    });
  };

  document.addEventListener('dynamic-collection:change', (event) => {
    if (event.detail?.handle) activateDynamicCollectionImageWithText(event.detail.handle);
  });

  const initializeDynamicCollectionImageWithText = () => {
    document.querySelectorAll('[data-dynamic-collection-image-with-text]').forEach((section) => {
      const requestedHandle = new URL(window.location.href).searchParams.get('collection');
      activateDynamicCollectionImageWithText(requestedHandle || section.dataset.initialHandle);
    });
  };

  initializeDynamicCollectionImageWithText();
  document.addEventListener('shopify:section:load', initializeDynamicCollectionImageWithText);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const arrangeCompactFooters = (root = document) => {
    root.querySelectorAll('.footer').forEach((footer) => {
      const top = footer.querySelector('.footer__top-wrapper');
      const brand = top?.querySelector(':scope > .footer-block--image_text');
      const newsletter = footer.querySelector('.footer-block--newsletter');
      const copyright = footer.querySelector('.footer__copyright-content');

      if (!brand) return;

      brand.classList.add('footer-block--brand-stack');

      if (newsletter && newsletter.parentElement !== brand) {
        brand.append(newsletter);
      }

      const existingEmail = footer.querySelector('.footer__contact-email');
      const emailParagraph = [...brand.querySelectorAll('.footer-image-box__text p')].find((paragraph) =>
        paragraph.textContent.includes('@')
      );

      if (!existingEmail && emailParagraph && copyright) {
        const emailAddress = emailParagraph.textContent.trim();
        const emailLink = document.createElement('a');

        emailLink.className = 'footer__contact-email';
        emailLink.href = `mailto:${emailAddress}`;
        emailLink.textContent = emailAddress;
        copyright.append(emailLink);
        emailParagraph.remove();
      }
    });
  };

  arrangeCompactFooters();

  document.addEventListener('shopify:section:load', (event) => {
    arrangeCompactFooters(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
